import { useEffect, useRef } from 'react';
import { useAuth } from 'react-oidc-context';
import { Outlet } from 'react-router';
import { LandingView } from '@src/views/Landing.view';
import { LoadingSpinner } from '@components/atoms/LoadingSpinner';

export function RootView() {
  const auth = useAuth();
  const triedSilentSignin = useRef(false);

  useEffect(() => {
    if (
      auth.isLoading ||
      auth.isAuthenticated ||
      auth.activeNavigator ||
      triedSilentSignin.current
    ) {
      return;
    }
    triedSilentSignin.current = true;
    auth.signinSilent().catch(() => {
      // No active Keycloak SSO session: fall through to LandingView.
    });
  }, [auth]);

  if (auth.isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <LoadingSpinner />
      </div>
    );
  }

  if (!auth.isAuthenticated) {
    return <LandingView />;
  }

  return <Outlet />;
}
